<template>
  <div>
    <h1 class="page-header">{{ $t('basicSalaryFormula.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-10"></div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record, index }">
            <td class="ts-whitespace-no-wrap">{{ record.shift_name }}</td>
            <td>{{ record.salary_per_day }}</td>
            <td>{{ record.salary_per_hour }}</td>
            <td>{{ record.total_days }}</td>
            <td>{{ record.total_hours }}</td>
            <td class="text-center">
              <span class="badge badge-success" v-if="record.is_end_of_month">Yes</span>
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.created_by }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.modified_by }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.created_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.modified_date }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'basic-salary-formula',
  components: {
    FormComponent
  },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/basicSalaryFormula', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.basicSalaryFormula.search
      },
      set(newValue) {
        this.$store.commit('hr/basicSalaryFormula/SET_SEARCH', newValue)
        this.$store.commit('hr/basicSalaryFormula/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('basicSalaryFormula.shiftName')
        },
        {
          name: this.$t('basicSalaryFormula.salaryPerDay')
        },
        {
          name: this.$t('basicSalaryFormula.salaryPerHours')
        },
        {
          name: this.$t('basicSalaryFormula.totalDay')
        },
        {
          name: this.$t('basicSalaryFormula.totalHours')
        },
        {
          name: this.$t('basicSalaryFormula.endOfMonth')
        },
        {
          name: this.$t('basicSalaryFormula.createdBy')
        },
        {
          name: this.$t('basicSalaryFormula.modifiedBy')
        },
        {
          name: this.$t('basicSalaryFormula.created')
        },
        {
          name: this.$t('basicSalaryFormula.modified')
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/basicSalaryFormula/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '480px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    edit(record) {
      this.showForm(record)
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/basicSalaryFormula/RESET_STATE')
    next()
  }
}
</script>

<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
